import { Repository } from './repository';

/**
 * @async
 * @callback InputsRepository~inputsGetter
 * @param {object} options - SEE BELOW
 * @param {string} options.namespace - The namespace to get the inputs from
 * @returns {Promise<Array<InputId>>} A promise of the current array of Inputs for the Applet Host in the shape of https://github.com/meltwater/inputs
 */
/**
 * @callback InputsRepository~inputsSetter
 *
 * @param {Array<InputId>} inputIds - The array of InputIds to update to in the shape of https://github.com/meltwater/inputs
 * @param {string} namespace - The namespace to set the inputs for
 * @throws {AppletHostError} `code` property is {@link AppletHostErrorCode.MAX_INPUT_LIMIT_EXCEEDED}, host application doesn't support the number of inputs provided.
 * @throws {TypeError} the provided array of inputs are not coercable to InputId
 * @throws {Error} - An unknown error or an error specific an applet host implementation
 * @returns {undefined}
 */

/**
 * @param {object} options - SEE BELOW
 * @param {InputsRepository~inputsGetter} options.get - Function to get the current date range in the shape of https://github.com/meltwater/inputs
 * @param {InputsRepository~inputsSetter} [options.set] - Function to set the current date range in the shape of https://github.com/meltwater/inputs
 */
export class InputsRepository extends Repository {}
